import type { SxProps, Theme } from '@mui/material';

/** Shared flex column styles so list header and rows stay aligned. */
export const eventListCol = {
    eventName: { flex: '5 1 0', minWidth: 0, textAlign: 'left' },
    course: { flex: '3 1 0', minWidth: 0, textAlign: 'left' },
    dates: { flex: '2 1 0', minWidth: 0, textAlign: 'center' },
    rounds: { flex: '0 0 56px', width: 56, minWidth: 56, maxWidth: 56, textAlign: 'center' },
    holes: { flex: '0 0 56px', width: 56, minWidth: 56, maxWidth: 56, textAlign: 'center' },
    field: { flex: '0 0 64px', width: 64, minWidth: 64, maxWidth: 64, textAlign: 'center' },
    playType: { flex: '1.5 1 0', minWidth: 0, textAlign: 'center' },
    privacy: { flex: '1.5 1 0', minWidth: 0, textAlign: 'center' },
    status: { flex: '0 0 48px', width: 48, minWidth: 48, maxWidth: 48, textAlign: 'center' },
} as const satisfies Record<string, SxProps<Theme>>;

/**
 * Reserve the same scrollbar gutter on header and body so columns align,
 * while letting only the body show a visible scrollbar.
 */
export const eventListScrollbarMatchSx: SxProps<Theme> = {
    width: '100%',
    boxSizing: 'border-box',
    overflowY: 'scroll',
    scrollbarGutter: 'stable',
};

/** Invisible scrollbar track on the header — keeps gutter, no visible bar. */
export const eventListHeaderScrollHideSx: SxProps<Theme> = {
    ...eventListScrollbarMatchSx,
    scrollbarWidth: 'thin',
    scrollbarColor: 'transparent transparent',
    '&::-webkit-scrollbar': {
        background: 'transparent',
    },
    '&::-webkit-scrollbar-thumb': {
        background: 'transparent',
    },
    '&::-webkit-scrollbar-track': {
        background: 'transparent',
    },
};